import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useSmoothScroll } from "../../../../hoc";
import { Card } from "../../../../shadcn/components/ui/card";
import BrandedButton from "../../../../shadcn/components/custom/BrandedButton";

export const ProfileCompletionCard: React.FC<{
  isComplete: boolean;
  percentage: number;
  firstInCompleteSection: any;
}> = ({ isComplete, percentage, firstInCompleteSection }) => {
  return (
    <div className="w-full">
      <Card
        className={`bg-white shadow-card-shadow p-4 rounded-[10px] space-y-4 ${
          isComplete ? "border-brand-orange border-2" : ""
        }`}
      >
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div>
            <h2 className="font-semibold">
              {isComplete ? (
                <span className="flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5 text-brand-orange" />
                  Profile Complete
                </span>
              ) : (
                "Complete Your Profile"
              )}
            </h2>
            <p className="text-sm text-brand-textGrey">
              {isComplete
                ? "Your profile is fully set up. You're ready to go!"
                : "Finish the steps below to unlock your full account experience"}
            </p>
          </div>
          <div>
            {isComplete ? (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-orange-100 text-brand-orange">
                Completed
              </span>
            ) : (
              <p className="text-sm">{percentage}% Completed</p>
            )}
          </div>
        </div>

        <ProgressBar value={percentage} isComplete={isComplete} />
        {!isComplete && (
          <PendingSections firstInCompleteSection={firstInCompleteSection} />
        )}
      </Card>
    </div>
  );
};

const PendingSections = ({
  firstInCompleteSection,
}: {
  firstInCompleteSection: any;
}) => {
  const { scrollToId } = useSmoothScroll();

  return (
    <>
      <div className="flex justify-end">
        <BrandedButton
          variant="primary"
          className="w-full md:w-auto"
          fullWidth
          onClick={() => scrollToId(firstInCompleteSection?.key)}
        >
          {firstInCompleteSection?.label
            ? `Complete ${firstInCompleteSection?.label} Section`
            : "Complete Profile"}
        </BrandedButton>
      </div>
    </>
  );
};

const ProgressBar = ({
  value,
  isComplete,
}: {
  value: number;
  isComplete: boolean;
}) => {
  return (
    <div className="w-full">
      <div className="flex gap-2 items-center">
        <div className="h-3 w-full rounded-full bg-gray-200 overflow-hidden">
          <div
            className={`h-full transition-all ${
              isComplete ? "bg-brand-orange" : "bg-brand-orange"
            }`}
            style={{ width: `${value}%` }}
          />
        </div>

        {!isComplete && <p className="text-sm">{value}%</p>}
      </div>
    </div>
  );
};
